import { WEB_NEW_FACETS } from "../constants";
import getFeatures from "./getFeatures";

const getNewFacets = state => {
  const { [WEB_NEW_FACETS]: facetIds = {} } = getFeatures(state);

  return Object.values(facetIds);
};

export default getNewFacets;
